<h1>Add User</h1>

<ng-form #userForm="ngForm" novalidate>
  <div class="form-container">

    <mat-form-field appearance="outline" required>
      <mat-label>User Name</mat-label>
      <mat-select #user="ngModel" name="user" [(ngModel)]="username" required>
        <ngx-mat-select-search name="userSearch" [(ngModel)]="userSearch" [placeholderLabel]="'Search...'"
          [noEntriesFoundLabel]="'notfound'"></ngx-mat-select-search>

        <mat-option value="" disabled selected>Please select</mat-option>
        <mat-option *ngFor="let usr of data.users | stringFilterBy : userSearch " [value]="usr">
          {{usr}}
        </mat-option>
      </mat-select>

    </mat-form-field>
  </div>

  <div class="form-container">

    <mat-form-field appearance="outline" required>
      <mat-label>Access Level</mat-label>
      <mat-select #levelCtrl="ngModel" name="level" [(ngModel)]="level" required>

        <mat-option value="" disabled selected>Please select</mat-option>
        <mat-option value="Initiator">Initiator</mat-option>
        <mat-option value="Read">Reader</mat-option>
      </mat-select>

    </mat-form-field>
  </div>

  <div class="form-container">
    <section class="custom-check-box-group">
      <mat-checkbox class="custom-check-box" name="Temprorary Access" [(ngModel)]="temporary"
        (click)="temporaryDate = undefined">Temporary Access</mat-checkbox>
    </section>
  </div>

  <div class="form-container" *ngIf="temporary">
    <mat-form-field appearance="outline" matTooltip="The date access will be removed">
      <mat-label>Access Expiry Date</mat-label>
      <input #accessExpiryDate="ngModel" name="accessExpiryDate" [(ngModel)]="temporaryDate" matInput
        [matDatepicker]="pickertemporaryDate" placeholder=" Choose a date yyyy/mm/dd" required [min]="today" />
      <mat-datepicker-toggle matSuffix [for]="pickertemporaryDate">
        <mat-icon matDatepickerToggleIcon><img src="assets/images/icon-calender.svg" /></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickertemporaryDate></mat-datepicker>

    </mat-form-field>
  </div>

  <ul class="table__control inline-list">
    <li>
      <button mat-raised-button (click)="onNoClick()" color="accent">Close</button>
    </li>
    <li>
      <button mat-raised-button
        [mat-dialog-close]="{name:username,level:level,direct:true,temporary:temporary,accessExpiryDate:temporaryDate}"
        cdkFocusInitial [disabled]="userForm.invalid" color="primary">Add</button>
    </li>
  </ul>
</ng-form>
